import loadable from '@loadable/component'

const prefix = '/ency'

const routes = [
  // 暂时不使用内置的 faq 页面
  // {
  //   path: `${prefix}/:key/faq`,
  //   component: loadable(() => import('./FAQ'))
  // },
  {
    path: `${prefix}/:key/:feature`,
    component: loadable(() => import('./Feature')),
  },
  {
    path: `${prefix}/:key`,
    component: loadable(() => import('./')),
  },
  {
    path: `/IframeContent`,
    component: loadable(() => import('./products/flc/IframeContent')),
  },
]

export default routes
